/* ============================================================================
 * Taskbar — the bottom dock: one centred strip of app tiles.
 * ----------------------------------------------------------------------------
 * Shape comes from the design source: a full-width 68px bar ruled with the brass
 * line, holding a single beveled strip. Tiles are icon + uppercase label.
 *
 * TILES ARE SKIN-AWARE. The master dock PNGs ship locked to the master palette,
 * so a fork wearing them shows colour it does not own. scripts/skin-art.py
 * compiles a FULL set per skin — the design source's crests AND the pixel tiles
 * this repo draws itself (LIVE_TV, IMMERSION_WIZARD, SKIN_BUILDER) — by mapping
 * the design ROLES the art is already authored in onto that skin's own tokens.
 *
 * Resolution and fallback both live in <SkinArt>, so the dock, the window
 * titlebar and the desk mastheads cannot drift apart on this again.
 * ========================================================================= */

import { APPS } from '../apps/registry';
import { SkinArt } from './SkinArt';

interface Props {
  onLaunch: (appId: string) => void;
  openAppIds: string[];
}

export function Taskbar({ onLaunch, openAppIds }: Props) {
  return (
    <nav id="taskbar" aria-label="Dock">
      <div className="taskbar__strip">
        {APPS.map((app) => (
          <button
            key={app.id}
            type="button"
            className="taskbar__tile"
            data-open={openAppIds.includes(app.id)}
            title={app.blurb}
            onClick={() => onLaunch(app.id)}
          >
            <SkinArt
              className="taskbar__tile-icon"
              src={app.tile}
              alt=""
              aria-hidden="true"
            />
            <span className="taskbar__tile-label">{app.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
